import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {StandingsWidgetDisplayEvent} from "../models/standings-widget.display-event";
import {StandingsWidgetState} from "../models/standings-widget.state";

export class StandingsWidgetDisplayEventHandler extends AnalyticsEventHandler {
  type = STANDINGS_WIDGET.ACTION_TYPES.displayHandler;
  state: StandingsWidgetState;

  async action(params) {
    const fullParams = {
      entityType: this.state.entityType,
      entityId: this.controller.props.competitorId || this.controller.props.competitionIds?.first(),
      sportTypeId: this.state.appStore.state.context.sportType?.id,
      ...params
    }

    const clickEvent: StandingsWidgetDisplayEvent = new StandingsWidgetDisplayEvent(fullParams);

    await this.analyticsService.createEvent(clickEvent);
  }
}
